import { useEffect, useState } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';
import AppShell from './components/layout/AppShell';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ChallengesPage from './pages/ChallengesPage';
import CreateChallengePage from './pages/CreateChallengePage';
import HomePageEditor from './pages/HomePageEditor';
import CarouselPage from './pages/CarouselPage';
import MetricsPage from './pages/MetricsPage';
import SubscriptionsPage from './pages/SubscriptionsPage';
import AppDataPage from './pages/AppDataPage';
import BugsPage from './pages/BugsPage';
import InterestPage from './pages/InterestPage';
import UnsubscribesPage from './pages/UnsubscribesPage';
import UserPage from './pages/UserPage';

function ProtectedRoute() {
  const [state, setState] = useState<'loading' | 'in' | 'out'>('loading');

  useEffect(() => {
    fetchAuthSession()
      .then((s) => {
        if (s.tokens?.idToken) setState('in');
        else setState('out');
      })
      .catch(() => setState('out'));
  }, []);

  if (state === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface text-ink-muted">
        Loading…
      </div>
    );
  }
  if (state === 'out') {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

function GuestOnly() {
  const [state, setState] = useState<'loading' | 'in' | 'out'>('loading');

  useEffect(() => {
    fetchAuthSession()
      .then((s) => {
        if (s.tokens?.idToken) setState('in');
        else setState('out');
      })
      .catch(() => setState('out'));
  }, []);

  if (state === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface text-ink-muted">
        Loading…
      </div>
    );
  }
  if (state === 'in') {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}

export default function App() {
  return (
    <Routes>
      <Route element={<GuestOnly />}>
        <Route path="/login" element={<Login />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/challenges/view" element={<ChallengesPage />} />
          <Route path="/challenges/create" element={<CreateChallengePage />} />
          <Route path="/challenges/create/:id" element={<CreateChallengePage />} />
          <Route path="/homepage" element={<HomePageEditor />} />
          <Route path="/carousel" element={<CarouselPage />} />
          <Route path="/metrics" element={<MetricsPage />} />
          <Route path="/subscriptions" element={<SubscriptionsPage />} />
          <Route path="/appdata" element={<AppDataPage />} />
          <Route path="/bugs" element={<BugsPage />} />
          <Route path="/interest" element={<InterestPage />} />
          <Route path="/unsubscribes" element={<UnsubscribesPage />} />
          <Route path="/user" element={<UserPage />} />
          <Route path="/user/:id" element={<UserPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
